export default class LoginEvent {

    static loginEvents: Array<() => void> = [];

    static addLoginCallback = (newLoginEvent: () => void) => {
        LoginEvent.loginEvents.push(newLoginEvent);
    }

    static callLoginEvents = () => {
        LoginEvent.loginEvents.forEach((event) => {
            event();
        })
    }

    static removeLoginCallback = (eventToRemove: () => void) => {
        LoginEvent.loginEvents = LoginEvent.loginEvents.filter(
            (event) => event !== eventToRemove
        );
    }
}
